module.exports = __webpack_public_path__ + "img/czw1.2938098f.png";